/* Who may supervise a library. */
.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

/* The picker and its button on one line, button aligned to the field's
   baseline rather than its label. */
.add {
  display: flex;
  align-items: flex-end;
  gap: var(--space-3);
}

.add > :first-child {
  flex: 1;
  min-width: 0;
}

.listBlock {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.listTitle {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  margin: 0;
  font-size: var(--text-xs);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-subtle);
}

.count {
  background: var(--bg-sunken);
  border: 1px solid var(--border);
  border-radius: var(--radius-full);
  padding: 0 0.4rem;
  letter-spacing: 0;
  color: var(--text-muted);
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-2) var(--space-3);
  background: var(--bg-sunken);
  border: 1px solid var(--border);
  border-radius: var(--radius);
}

.who {
  display: flex;
  flex-direction: column;
  gap: 0.0625rem;
  min-width: 0;
}

.whoName {
  font-size: var(--text-base);
  font-weight: 500;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.whoMail {
  font-size: var(--text-xs);
  color: var(--text-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.muted {
  margin: 0;
  font-size: var(--text-sm);
  color: var(--text-muted);
}

.note {
  margin: 0;
  padding-top: var(--space-3);
  border-top: 1px solid var(--border);
  font-size: var(--text-xs);
  color: var(--text-subtle);
}

/* Phone: the picker stacks above its button rather than squeezing both. */
@media (max-width: 30rem) {
  .add {
    flex-direction: column;
    align-items: stretch;
  }
}
